import { makeObservable } from "mobx"

import { themeKey, THEMES } from "@src/app/styles/themes/theme"
import { wrapSingleton } from "@src/shared/classes/utils/wrapSingleton"

class UiStore {
  theme: THEMES = themeKey

  constructor() {
    makeObservable(this)
  }

  get isTransferioTheme() {
    return this.theme === THEMES.TRANSFERIO
  }
}

export default wrapSingleton(UiStore)
